import { render } from "./assetsView.vue?vue&type=template&id=38ae1139"
import script from "./assetsView.vue?vue&type=script&lang=js"
export * from "./assetsView.vue?vue&type=script&lang=js"

import exportComponent from "I:\\Dev\\Projects\\LabManagement\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__